import React, { useState, useEffect } from "react";
import "./Encyclopedia.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import Book from "../../../Assets/img/book.png";
import Investment from "../../../Assets/img/investment.png";
import suitcase from "../../../Assets/img/suitcase.png";
import traveller from "../../../Assets/img/traveller.png";
import stayathome from "../../../Assets/img/stay-at-home.png";
import building from "../../../Assets/img/building.png";
import policy from "../../../Assets/img/policy.png";
import axios from "axios";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useParams, useNavigate } from "react-router-dom";

function CountrySingle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [country, setCountry] = useState(null);

  useEffect(() => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/v1/get-country/${id}`)
      .then((res) => {
        console.log(res);
        setCountry(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const goToDetails = (details, title) => {
    navigate("/details", {
      state: {
        details: details,
        title: title,
        country: country?.country,
      },
    });
  };

  return (
    <div className="countsingle">
      <Header title={country?.country || "کشور"} />

      {country ? (
        <div className="countrysingle">
          <div className="countrysingle-body">
            <div className="countrysingle-header">
              <div className="countrysingle-icon-box">
                <img src={country.img?.url} alt="country" />
              </div>
              <h4>{country.country}</h4>
            </div>

            <div className="countrysingle-boxes">
              <div
                className="countrysingle-box"
                onClick={() => goToDetails(country.studyVisa, "ویزای تحصیلی")}
              >
                <img src={Book} alt="book" />
                <h4>ویزای تحصیلی</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() =>
                  goToDetails(country.InvestmentVisa, "ویزای سرمایه گذاری")
                }
              >
                <img src={Investment} alt="Investment" />
                <h4>ویزای سرمایه گذاری</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() => goToDetails(country.jobVisa, "ویزای کاری")}
              >
                <img src={suitcase} alt="suitcase" />
                <h4>ویزای کاری</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() =>
                  goToDetails(country.touristVisa, "ویزای توریستی")
                }
              >
                <img src={traveller} alt="traveller" />
                <h4>ویزای توریستی</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() => goToDetails(country.stay, "اقامت")}
              >
                <img src={stayathome} alt="stayathome" />
                <h4>اقامت</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() =>
                  goToDetails(country.importantCities, "شهر های مهم")
                }
              >
                <img src={building} alt="building" />
                <h4>شهر های مهم</h4>
              </div>

              <div
                className="countrysingle-box"
                onClick={() => goToDetails(country.description, "توضیحات")}
              >
                <img src={policy} alt="policy" />
                <h4>توضیحات</h4>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="spinner">
          <Loader
            type="TailSpin"
            color="rgb(236, 177, 28)"
            height={80}
            width={80}
          />
        </div>
      )}

      <Footer />
    </div>
  );
}

export default CountrySingle;